"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-ignorelist-container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('ignore_list')))]), _vm.onlineIgnoredUsers.length > 0 ? _c('table', {
    staticClass: "kiwi-ignorelist-table"
  }, [_vm._m(0), _vm._l(_vm.onlineIgnoredUsers, function (user) {
    return _c('tr', {
      key: user.nick
    }, [_c('td', [_vm._v(_vm._s(user.nick))]), _c('td', [_c('a', {
      staticClass: "u-link",
      on: {
        "click": function ($event) {
          return _vm.removeIgnore(user.nick);
        }
      }
    }, [_vm._v(" Remove ")])])]);
  })], 2) : _vm._e(), _vm.offlineIgnoredUsers.length > 0 ? _c('table', {
    staticClass: "kiwi-ignorelist-table"
  }, [_vm._m(1), _vm._l(_vm.offlineIgnoredUsers, function (user) {
    return _c('tr', {
      key: user
    }, [_c('td', [_vm._v(_vm._s(user))]), _c('td', [_c('a', {
      staticClass: "u-link",
      on: {
        "click": function ($event) {
          return _vm.removeIgnore(user);
        }
      }
    }, [_vm._v(" Remove ")])])]);
  })], 2) : _vm._e(), _vm.onlineIgnoredUsers.length === 0 && _vm.offlineIgnoredUsers.length === 0 ? _c('span', {
    staticClass: "kiwi-ignorelist-empty"
  }, [_vm._v(" " + _vm._s(_vm.$t('ignore_list_empty')) + " ")]) : _vm._e()]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Online")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Offline")])]);
}];